import React, { useEffect } from "react";
import "./gallery.css";

const GalleryLightbox = ({ images, index, onClose, onNext, onPrev }) => {

  const image = images[index];

  useEffect(() => {

    const handleKey = (e) => {

      if (e.key === "Escape") onClose();

      if (e.key === "ArrowRight") onNext();

      if (e.key === "ArrowLeft") onPrev();

    };

    window.addEventListener("keydown", handleKey);

    return () => window.removeEventListener("keydown", handleKey);

  }, [index]);

  if (!image) return null;

  return (
    <div className="lightbox-overlay">

      <button className="lightbox-close" onClick={onClose}>
        ✕
      </button>

      <button className="lightbox-prev" onClick={onPrev}>
        ‹
      </button>

      <img
        src={image.image.url}
        alt=""
        className="lightbox-image"
      />

      <button className="lightbox-next" onClick={onNext}>
        ›
      </button>

    </div>
  );
};

export default GalleryLightbox;
